import React from "react";

const Loading = ({
  size = "medium",
  text = "Loading...",
  showText = true,
  className = "",
}) => {
  const sizeClasses = {
    small: "w-6 h-6",
    medium: "w-8 h-8",
    large: "w-12 h-12",
    xl: "w-16 h-16",
  };

  const textSizeClasses = {
    small: "text-sm",
    medium: "text-base",
    large: "text-lg",
    xl: "text-xl",
  };

  return (
    <div
      className={`flex items-center justify-center h-full gap-3 ${className}`}
    >
      <div className="relative">
        {/* Outer spinning ring */}
        <div
          className={`${sizeClasses[size]} border-4 border-gray-200 border-t-dupontBlue dark:border-darkTextTertiary/40 dark:border-t-darkGold rounded-full animate-spin`}
        ></div>

        {/* Inner pulsing dot */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div className="w-2 h-2 bg-dupontBlue dark:bg-darkGold rounded-full animate-pulse"></div>
        </div>
      </div>

      {showText && (
        <p
          className={`${textSizeClasses[size]} text-gray-600 dark:text-darkTextSecondary font-medium animate-pulse`}
        >
          {text}
        </p>
      )}
    </div>
  );
};

export default Loading;
